import { ApiService } from '@/api';
import { Theme } from '@/models';

export class ThemeApi {
  private readonly baseUrl = '/api/theme';

  public async fetchCurrentTheme(): Promise<Theme> {
    const response =  await ApiService.get(`${this.baseUrl}`);
    return response.json();
  }
}
